export default "__VITE_ASSET__fvYaFf8V__"